<template>
  <div class="scroll-y custom-scrollbar">
    <ion-row>
      <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
        <div class="padding">

          <div class="text-left mb-20">
            <div class="text-left mt-10 mb-10">
              <button class="link" @click="goTo('UserIndex')">
                <span class="pd-0">&larr; Wróć do profilu</span>
              </button>
            </div>
            <h1 class="h1">Usuwasz konto?</h1>
            <p>Przechodząc przez ten proces stracisz dostęp do:</p>
            <p class="mb-20">- swojego profilu<br/>
              - realizowania wyzwań<br/>
              - najnowszych informacji o produktach VOX i Vilo<br/>
            </p>

            <hr/>

            <form class="form form-user-delete" @submit.prevent="postUserDelete">

              <div class="approval-list">
                <!--list-->
                <template v-for="item in approvalsCollection">
                  <div class="item-approval">
                    <div class="item-input">
                      <ion-checkbox
                        slot="start"
                        @input="checked = target.value"
                        @ionChange="handleCheckbox($event, item.id, item.name)"
                        v-model="checkboxes[item.name]"
                        :required="item.required"
                        mode="md">
                      </ion-checkbox>
                    </div>
                    <!--TODO @click change checkbox-->
                    <div class="item-description">
                      <div>{{ item.name }}</div>
                    </div>
                  </div>
                </template>

                <!--errors-->
                <p class="error" v-if="errors.approvals">
                  <svg class="voxion">
                    <use xlink:href="#icon-alert"></use>
                  </svg>
                  <span v-text="errors.approvals"></span>
                </p>
              </div>

              <button class="btn btn-primary" type="submit" :disabled="disabled">
                <span v-if="loading"><span class="loader"></span></span>
                <span v-else>Potwierdź</span>
              </button>

            </form>

          </div>


        </div>
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
import api from '@/services/Api';

export default {
  name: 'UserDelete',
  data() {
    return {
      loading: false,
      errors: [],
      approvalsCollection: null,
      checkboxes: []
    }
  },
  computed: {
    disabled() {
      return this.checkboxes.length > 0 ? false : true
    }
  },
  mounted() {
    this.getApprovals()
  },
  methods: {
    goTo(name) {
      this.$router.push({name: name})
    },
    handleCheckbox(event, id, name) {
      if (event.detail.checked === true) {
        this.checkboxes.push({'id': id, 'name': name, 'value': event.detail.checked})
      } else {
        let index = this.checkboxes.map((item) => {
          return item.id
        }).indexOf(id);
        this.checkboxes.splice(index, 1)
      }
    },
    getApprovals() {
      this.loading = true;
      const url = '/api/v1/approval/delete-user'
      api.get(url).then(response => {
        this.loading = false;
        this.approvalsCollection = response.data.data
      })
    },
    postUserDelete() {
      this.loading = true;
      const url = 'api/v1/user/delete'
      const data = {
        'approvals': this.checkboxes
      }
      api.post(url, data).then(response => {
        // success
        this.$ionic.toastController
          .create({
            message: 'Usunięto konto. Za chwilę zostaniesz wylogowany',
            duration: 5000,
            mode: 'md'
          })
          .then(a => a.present())
        // wait for user to read message
        setTimeout(() => {
          // logout
          this.$store.dispatch('AUTH_LOGOUT');
          this.$router.push({name: 'Login'});
          //
          this.$gtag.event('user', 'delete')
          //
          return this.$ionic.toastController
            .create({
              message: 'Wylogowano poprawnie.',
              duration: 2000,
              mode: 'md'
            })
            .then(a => a.present())
        }, 5000)
      }).catch(err => {
        this.loading = false;
        if (err.response && err.response.data && err.response.data.errors) {
          this.errors = err.response.data.errors
        }
        //
        this.$ionic.toastController
          .create({
            message: err.response.data.message ? err.response.data.message : 'Błąd serwera.',
            duration: 2000,
            mode: 'md'
          })
          .then(a => a.present());
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.approval-list {
  margin: 20px 0;

  .item-approval {
    display: flex;
    width: 100%;

    .item-input {
      width: 30px;
      max-width: 30px;
      min-width: 30px;
    }

    .item-description {
      margin: 0 7px 0px;
    }
  }
}
</style>
